import React from 'react';
import { ArrowRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export function InteractiveHoverButton({
  children,
  className,
  onClick,
  href,
  ...props
}) {
  const content = (
    <>
      <span className="inline-block transition-all duration-300 group-hover:translate-x-12 group-hover:opacity-0">
        {children}
      </span>
      <div className="absolute top-0 z-10 flex h-full w-full translate-x-12 items-center justify-center gap-2 opacity-0 transition-all duration-300 group-hover:-translate-x-0 group-hover:opacity-100">
        <span>{children}</span>
        <ArrowRight className="h-4 w-4" />
      </div>
    </>
  );

  const baseClasses = cn(
    'group relative flex cursor-pointer items-center justify-center overflow-hidden rounded-xl border border-amber-500/50 bg-amber-500 px-6 py-3 text-center text-sm font-bold text-slate-950 shadow-md shadow-amber-500/20 transition-all duration-300 hover:bg-amber-400 hover:scale-105 active:scale-95 dark:bg-amber-500 dark:text-slate-950 dark:hover:bg-amber-400',
    className
  );

  if (href) {
    return (
      <a href={href} className={baseClasses} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={baseClasses} {...props}>
      {content}
    </button>
  );
}
